import React from "react";

export default function ProficiencyLevels_Id() {
  return (
    <>
      <h2>Penjelasan tingkat kecakapan</h2>
      <div>
      Untuk lebih memahami profil kompetensi diri, Anda sebaiknya melihat kinerja berdasarkan area. Hal itu akan memberikan Anda gambaran pertama yang dapat membantu Anda menentukan kelemahan dan kekuatan relatif Anda, sambil memberi Anda saran dan ide bagaimana cara mengembangkan praktik digital Anda.
        <ul>
          <li>Tingkat A: 0/192 poin, 0%</li>
          <li>Tingkat B: sampai dengan 64/192 poin, di atas 33%</li>
          <li>Tingkat C: 65-128/192 poin, 34-67%</li>
          <li>Tingkat D: 129-192/192 poin 68-100%</li>
        </ul>
      </div>
      <div>
        <h3> Tingkat A: Tidak terbiasa digital</h3>
        <div style={{ marginBottom: "20px" }}>
        Anda berada di awal perjalanan digital Anda dalam pendidikan. Mungkin dunia perangkat dan teknik digital yang luas terasa asing dan sedikit menakutkan. Meskipun Anda mungkin belum banyak (jika sudah) menjelajahi atau menggunakan strategi digital dalam pengajaran, Anda memiliki rasa ingin tahu  dan kemauan untuk belajar. Saat Anda memulai perjalanan ini, ingatlah bahwa semua orang memulainya dari suatu tempat. Dengan sumber daya dan dukungan yang tepat, Anda akan segera menemukan pijakan Anda, menemukan berbagai kemungkinan yang tak terbatas yang ditawarkan dari integrasi digital untuk meningkatkan pengajaran Anda.
        </div>
      </div>
      <div>
        <h3> Tingkat B: Pemula Digital</h3>
        <div style={{ marginBottom: "20px" }}>
        Anda mungkin sudah mencoba beberapa perangkat digital, dan Anda sedang memikirkan cara untuk mengintegrasikannya lebih konsisten. Saat Anda menyelami lebih dalam, Anda akan memahami berbagai cara di mana alat-alat ini dapat meningkatkan strategi pengajaran Anda, yang mengarahkan Anda untuk mengeksplor dan bereksperimen dalam konteks yang berbeda.
        </div>
      </div>
      <div>
        <h3>Tingkat C: Praktisi Digital</h3>
        <div style={{ marginBottom: "20px" }}>
        Anda telah melampaui dasar-dasar dan mengintegrasikan teknologi digital ke dalam praktik sehari-hari Anda. Strategi digital Anda semakin berkembang, dan Anda menguasai seni memilih alat yang tepat untuk setiap situasi. Anda melihat baik kelebihan maupun kelemahan dari berbagai pendekatan digital. Dengan terus bereksperimen dan melakukan refleksi, Anda dapat menyempurnakan metode Anda. Dan seiring dengan berkembangnya keahlian, Anda akan menemukan diri Anda berbagi wawasan dan membimbing rekan-rekan Anda dalam perjalanan digital mereka.
        </div>
      </div>
      <div>
        <h3>Tingkat D: Inovator Digital</h3>
        <div style={{ marginBottom: "20px" }}>
        Anda berada di garis depan inovasi digital dalam pendidikan. Pendekatan Anda dalam menggunakan teknologi digital begitu luas dan mendalam, dan memungkinkan Anda untuk secara konsisten memilih strategi terbaik. Anda bukan hanya seorang pengguna; Anda adalah seorang pemimpin, menciptakan tren dan membantu orang lain dalam perjalanan mereka. Anda terus memperbarui diri dalam inovasi digital yang terbaru dan terus memperluas batas dalam upaya Anda untuk berinovasi lebih jauh. Meskipun Anda menjadi panutan di komunitas Anda, Anda tetap terbuka dan responsif terhadap ide-ide baru, memastikan bahwa Anda selalu siap untuk mengambil langkah inovatif berikutnya.
        </div>
      </div>

    </>
  );
}
